<template>
  <div>
    <form-navigation-tabs
      :tabs="tabs"
      v-on:selected="setActive"
      :active="currentView"
      :enable-logging="true"
      :incident="incident"
      :module="module"
      :parentTabs="['Recovery']"
      class="margin-t-10"
    ></form-navigation-tabs>

    <dates
      key="dates"
      :incident="incident"
      v-if="currentView == 'dates'"
    ></dates>

    <fieldset
      :disabled="readonly"
      style="border:0;padding:0;margin:0;min-width:0;"
    >
      <figures
        :incident="incident"
        :recovery="recovery"
        :recovery-form="recoveryForm"
        :hire-form="hireForm"
        :rates-form="ratesForm"
        :hire-monitoring="hire_monitoring"
        :has-hire="hasHire"
        v-show="currentView === 'figures'"
      ></figures>

      <payments
        :incident="incident"
        :recovery="recovery"
        key="payments"
        v-show="currentView == 'payments'"
      ></payments>
    </fieldset>

    <documents
      :incident="incident"
      :recovery="recovery"
      key="documents"
      v-show="currentView == 'documents'"
    ></documents>

    <fieldset
      :disabled="readonly"
      style="border:0;padding:0;margin:0;min-width:0;"
    >
      <escalations
        :incident="incident"
        v-if="currentView == 'escalations'"
        key="escalations"
      ></escalations>
    </fieldset>
  </div>
</template>
<script>
import Figures from './Figures';
import Dates from './Dates';
import Payments from './Payments';
import Documents from './Documents';
import Escalations from './Escalations.vue';
import CurrencyInput from '@/components/Generic/Form/CurrencyInput';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    module: {
      type: String,
      required: true
    },
    recovery: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false
    }
  },

  components: {
    Figures,
    Payments,
    Dates,
    Documents,
    Escalations
  },

  data() {
    return {
      currentView: 'figures',
      tabs: [
        {
          name: 'figures',
          label: 'Figures'
        },
        {
          name: 'dates',
          label: 'Dates'
        },
        {
          name: 'payments',
          label: 'Payments'
        },
        {
          name: 'documents',
          label: 'Documents'
        },
        {
          name: 'escalations',
          label: 'Escalations'
        }
      ],
      hire_monitoring: {},
      hasHire: false,
      recoveryForm: new window.Form({
        global_offer_enabled: false,
        global_offer_accepted: false,
        global_offer: null,
        status_id: null,
        is_gta: false,
        include_vat: false,
        outstanding_claim_reason_category_id: null,
        outstanding_claim_reason_id: null,
        reason_not_issued_id: null
      }),
      hireForm: new window.Form({
        total_days: null,
        total_days_agreed: null,
        hold_back_reason_id: null
      }),
      ratesForm: new window.Form({
        rates: {}
      })
    };
  },

  mounted() {
    if (this.recovery) {
      this.setRecovery(this.recovery);
    }

    window.Ajax.get(`/claim-monitoring/${this.incident}`)
      .then(response => {
        this.hire_monitoring = response.data;

        if (this.hire_monitoring.claim_type) {
          this.type = this.hire_monitoring.claim_type.name;
        }
      })
      .catch(error => {});
  },

  methods: {
    setRecovery(recovery) {
      this.recoveryForm.global_offer_enabled =
        recovery.global_offer_enabled || false;
      this.recoveryForm.global_offer_accepted =
        recovery.global_offer_accepted || false;
      this.recoveryForm.global_offer = recovery.global_offer;
      this.recoveryForm.status_id = recovery.status_id;
      this.recoveryForm.outstanding_claim_reason_category_id =
        recovery.outstanding_claim_reason_category_id;
      this.recoveryForm.outstanding_claim_reason_id =
        recovery.outstanding_claim_reason_id;
      this.recoveryForm.reason_not_issued_id = recovery.reason_not_issued_id;
      this.recoveryForm.is_gta = recovery.is_gta || false;
      this.recoveryForm.include_vat = recovery.include_vat || false;
      this.recoveryForm.company_id = recovery.company_id;
      this.recoveryForm.company_name = recovery.company_name;
      this.recoveryForm.company_email_address = recovery.company_email_address;
      this.recoveryForm.company_telephone_number =
        recovery.company_telephone_number;
      this.recoveryForm.company_address_line_one =
        recovery.company_address_line_one;
      this.recoveryForm.company_address_line_two =
        recovery.company_address_line_two;
      this.recoveryForm.company_city = recovery.company_city;
      this.recoveryForm.company_postcode = recovery.company_postcode;
      this.recoveryForm.solicitors_reference = recovery.solicitors_reference;

      if (recovery.hire) {
        this.hasHire = true;

        this.hireForm.total_days = recovery.hire.total_days;
        this.hireForm.total_days_agreed = recovery.hire.total_days_agreed;
        this.hireForm.hold_back_reason_id = recovery.hire.hold_back_reason_id;
      }

      this.ratesForm.rates = {};

      if (recovery.rates) {
        recovery.rates.forEach(rate => {
          this.ratesForm.rates[rate.id] = rate;
        });
      }
    },

    setActive(tab) {
      this.currentView = tab;
    }
  },

  watch: {
    recovery(recovery) {
      this.setRecovery(recovery);
    }
  }
};
</script>
